import React, { Fragment } from 'react'
import { Grid, Box, Typography, Button } from "@mui/material";
import { styled } from '@mui/system';
import { useResponsive } from '../../../hooks/use-responsive';
import Image from '../../image';
import Iconify from '../../iconify';
import { useNavigate } from 'react-router-dom';
import { paths } from "../../../routes/paths.js";
import './referAndEarn.css';

function ReferEarnKeyBenefits() {
    const mdUp = useResponsive("up", "md");
    const navigate = useNavigate();
    const GetReferralCode = styled(Button)(({ theme }) => ({
        backgroundColor: "#C7F760",
        color: "#1E53E8",
        fontFamily: "Roboto Flex",
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        boxShadow: "none",
        "& .icon-hover": {
            transition: "color 0.3s ease",
        },
        "&:hover": {
            backgroundColor: "#1E53E8",
            color: "#C7F760",
            transform: "scale(1.05)",
        },

        "&:active": {
            backgroundColor: "#1E53E8",
            transform: "scale(1)",
        },
    }));
    const handleReferralClick = () => {
        const accessToken = localStorage.getItem('accessToken');

        if (accessToken) {
            navigate(paths.dashboard.referAndEarn);
        } else {
            navigate('/user_login');
        }
    };
    return (
        <Fragment  >
            <Box
                sx={{
                    padding: { xl: '64px', md: '64px', xs: '28px 24px' },
                    backgroundColor: '#FFFFFF',

                }}
            >
                <Grid container spacing={1} columnSpacing={'80px'} rowSpacing={'26px'} >
                    <Grid item xs={12} md={6}>


                        {mdUp && (
                            <Typography
                                className="HeroHeadingNewRNE"
                                textAlign="left"
                                sx={{ pb: '28px' }}
                            >
                                Give the Gift of a Safe, Fast, and
                                <span className='HeroHeadingItalic' style={{ color: "#1E53E8" }}> Fun Digital World </span>
                            </Typography>
                        )}
                        {!mdUp && (
                            <Typography
                                className="HeroHeadingNewRNE"
                                textAlign="center"
                                sx={{ pb: '14px' }}
                            >
                                Give the Gift of a Safe, Fast, and
                                <span className='HeroHeadingItalic' style={{ color: "#1E53E8" }}> Fun Digital World </span>
                            </Typography>
                        )}
                        {mdUp && (
                            <Typography
                                className="heroTextNewRnE"
                                textAlign="left"
                                fontSize='28'
                            >
                                By sharing MegaConnect, you're giving families a worry-free digital
                                experience. Our high-speed cloud PC for kids ensures a safe, productive
                                environment where they can learn, create, and explore securely.
                            </Typography>
                        )}
                        {!mdUp && (
                            <Typography
                                className="heroTextNewRnE"
                                textAlign="center"
                            >
                                By sharing MegaConnect, you're giving families a worry-free digital
                                experience. Our high-speed cloud PC for kids ensures a safe, productive
                                environment where they can learn, create, and explore securely.
                            </Typography>
                        )}


                        {mdUp && <Box
                            sx={{
                                mt: 3,
                                display: "grid",
                                rowGap: 2,
                                columnGap: 3,
                                gridTemplateColumns: {
                                    xs: "repeat(1, 1fr)",
                                    sm: "repeat(1, 1fr)",
                                    md: "repeat(1, 1fr)",
                                },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                <Image src='/assets/ReferAndEarnKeyBenefits.svg' sx={{ maxWidth: '30px', maxHeight: 'auto', }} />
                                <Typography className='KeyBenefitsSubTitle' sx={{ display: 'flex', alignItems: 'center', fontSize: {md:'24px', xs:'28px'} }}>
                                    &nbsp;<span  > Key Benefits</span>
                                </Typography>
                            </Box>
                            <Typography sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start',
                                gap: '2px'
                            }}
                            >
                                <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                &nbsp;<span className='KeyBenefitsText' > <span className='KeyBenefitsTextItalic'>Instant Cashback :</span> Earn 50% cashback directly to your UPI account with every successful referral.</span>
                            </Typography>
                            <Typography sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start',
                                gap: '2px'
                            }}>
                                <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                &nbsp;<span className='KeyBenefitsText' > <span className='KeyBenefitsTextItalic'> Unlimited Earnings :</span> No limit on earnings, keep getting cashback with every successful referral.</span>
                            </Typography>
                            <Typography sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start',
                                gap: '2px'
                            }}>
                                <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                &nbsp;<span className='KeyBenefitsText' > <span className='KeyBenefitsTextItalic'> 50% Discount for Friends :</span> Your referrals get an instant 50% off their first payment.</span>
                            </Typography>

                        </Box>
                        }
                    </Grid>
                    {/* First Grid: Accordion List */}
                    <Grid item xs={12} md={6} sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    >
                        <Image
                            src="/assets/ReferAndEarn-Hero-Illustration.svg"
                            alt={'ReferAndEarnVideo'}
                            sx={{
                                width: "100%",
                                maxWidth: "100%",
                                height: "auto",
                                objectFit: "fill",
                            }}
                        />
                        {/* <video
                            width="100%"
                            height={'100%'}
                            style={{ borderRadius: 15, border:'1px solid blue' }}
                            muted // Start muted; unmute when video is in view
                            autoPlay
                            loop
                        >
                            <source src="/assets/ReferAndEarnVideo.svg" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video> */}
                    </Grid>

                </Grid>
                {!mdUp && <Box
                    sx={{
                        mt: 3,
                        display: "grid",
                        rowGap: 2,
                        columnGap: 3,
                        gridTemplateColumns: {
                            xs: "repeat(1, 1fr)",
                            sm: "repeat(1, 1fr)",
                            md: "repeat(1, 1fr)",
                        },
                    }}
                >
                    <Typography className='KeyBenefitsSubTitle' sx={{ display: 'flex', alignItems: 'center', }}>
                        <Image src='/assets/ReferAndEarnKeyBenefits.svg' sx={{ maxWidth: '30px', maxHeight: 'auto', }} />
                        &nbsp; Key Benefits
                    </Typography>
                    <Typography sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '2px'
                    }}
                    >
                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                        &nbsp;<span className='KeyBenefitsText' > <span className='KeyBenefitsTextItalic'>Instant Cashback :</span> Earn 50% cashback directly to your UPI account with every successful referral.</span>
                    </Typography>
                    <Typography sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '2px'
                    }}>
                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                        &nbsp;<span className='KeyBenefitsText' > <span className='KeyBenefitsTextItalic'> Unlimited Earnings :</span> No limit on earnings, keep getting cashback with every successful referral.</span>
                    </Typography>
                    <Typography sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '2px'
                    }}>
                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                        &nbsp;<span className='KeyBenefitsText' > <span className='KeyBenefitsTextItalic'> 50% Discount for Friends :</span> Your referrals get an instant 50% off their first payment.</span>
                    </Typography>

                </Box>
                }
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: { xl: '38px  0px  0px  0px', md: '38px  0px  0px  0px', xs: '18px 0px' } }} >
                    <Grid
                        container
                        md={4}
                        justifyContent="center"
                    >
                        <GetReferralCode
                            variant="contained"
                            fullWidth
                            size="large"
                            onClick={handleReferralClick}
                            sx={{
                                color: "#1E53E8",
                                fontWeight: "bold",
                                background: "#C7F760",
                                padding: 1,
                                borderRadius: 2,
                            }}
                        >
                            Get Your Referral Code
                        </GetReferralCode>
                    </Grid>
                </Box>
            </Box>
        </Fragment>
    )
}

export default ReferEarnKeyBenefits
